<template>
  <div class="quote search-object-teaser">
    <button
      class="d-md-none visually-hidden"
      type="button"
      :data-ident="`toggleClip1`"
      @click="toggleClip"
    >
      {{ $t('common:expandText') }}
    </button>
    <!-- eslint-disable-next-line vuejs-accessibility/click-events-have-key-events -->
    <div
      v-dompurify-html="aexeaTeaser"
      class="clipped"
      :data-ident="`toggleClip2`"
      @click="toggleClip"
    />
  </div>
</template>

<script>

export default {
  name: 'SearchAexea',
  props: {
    aexeaTeaser: {
      type: String,
      default: '',
    },
  },
  methods: {
    toggleClip(event) {
      event.target.parentElement.classList.toggle('clipped');
    },
  },
};
</script>

<style lang="scss">
  .search-object-teaser {
    @media #{$media_sm_max} {
      .clipped p {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
    }
  }
</style>
